import React from 'react'
import { Button } from '../buttons/Button/Button'
import {
    StyledPollieRaterContainer,
    StyledPolliImage,
    StyledPolliImageContainer,
    StyledPolliTextContainer,
    StyledRatingLabel,
    StyledRatingsContainer,
    StyledRatingScore,
} from './PollieRater.styled'

const mainPhoto = require('./assets/temp.jpg')
export function PollieRater(props: any) {
    return (
        <StyledPollieRaterContainer>
            <StyledPolliImageContainer>
                <StyledPolliImage src={mainPhoto} alt="" />
            </StyledPolliImageContainer>
            <StyledPolliTextContainer>
                <div>
                    <h2>Scott Morrison</h2>
                    <h3>
                        Liberal - <span>Prime Minister</span>
                    </h3>
                    <p>
                        Scott Morrison is the Prime Minister of Australia and
                        the leader of the Federal Liberal Party. Mr Morrison
                        became PM after he overthrew Malcolm Turnbull as Liberal
                        leader in August 2018. He went on to win the 2019
                        Federal election and is currently the longest serving
                        Prime Minister since John Howard.
                    </p>
                </div>
                <div>
                    <Button>Submit</Button>
                </div>
            </StyledPolliTextContainer>
            <StyledRatingsContainer>
                <div>
                    <StyledRatingScore>
                        <em>8</em>/10
                    </StyledRatingScore>{' '}
                    <StyledRatingLabel>Expert Rating</StyledRatingLabel>
                </div>
                <div>
                    <StyledRatingScore>
                        <em>8</em>/10
                    </StyledRatingScore>{' '}
                    <StyledRatingLabel>Average Voter Rating</StyledRatingLabel>
                </div>
            </StyledRatingsContainer>
        </StyledPollieRaterContainer>
    )
}
export default PollieRater
